var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0_8569_28694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.833H6.25V13h3.125v12.5h5.208V13h3.794l.373-4.167h-4.167V7.097c0-.995.2-1.389 1.162-1.389h3.005V.5h-3.967c-3.745 0-5.408 1.649-5.408 4.807v3.526z",
    fill: "#464D53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0_8569_28694"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h25v25H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzg1NjlfMjg2OTQpIj4KPHBhdGggZD0iTTkuMzc1IDguODMzMzNINi4yNVYxM0g5LjM3NVYyNS41SDE0LjU4MzNWMTNIMTguMzc3MUwxOC43NSA4LjgzMzMzSDE0LjU4MzNWNy4wOTY4N0MxNC41ODMzIDYuMTAyMDggMTQuNzgzMyA1LjcwODMzIDE1Ljc0NDggNS43MDgzM0gxOC43NVYwLjVIMTQuNzgzM0MxMS4wMzc1IDAuNSA5LjM3NSAyLjE0ODk2IDkuMzc1IDUuMzA3MjlWOC44MzMzM1oiIGZpbGw9IiM0NjRENTMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF84NTY5XzI4Njk0Ij4KPHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgFacebook as ReactComponent };